import { ServiceBase } from '../../../../../../core/services/ServiceBase'
import Proxy from './Proxy'

class Service extends ServiceBase {
  postPeerAnalysisSearch(params) {
    return this.getData(() => Proxy.postPeerAnalysisSearch(params))
  }
}

export default new Service()
